import { useSearchParams } from 'react-router';
import { useEffect, useState } from 'react';
import { envIsProduction } from 'dg-web-shared/lib/Environment.ts';

const paramName = 'forceVisibility';

export function useForceProductVisibility() {
    const [searchParams, setSearchParams] = useSearchParams();
    const forceVisibilityParam = searchParams.get(paramName);
    const [forceVisibility, setForceVisibility] = useState(
        !envIsProduction() && Boolean(forceVisibilityParam),
    );
    useEffect(() => {
        if (!envIsProduction()) {
            if (!forceVisibility && forceVisibilityParam === 'true') {
                const timeoutId = setTimeout(() => setForceVisibility(true), 0);
                return () => clearTimeout(timeoutId);
            }
            if (forceVisibility && forceVisibilityParam === 'false') {
                const timeoutId = setTimeout(
                    () => setForceVisibility(false),
                    0,
                );
                const newParams = new URLSearchParams(searchParams);
                newParams.delete(paramName);
                setSearchParams(newParams);
                return () => clearTimeout(timeoutId);
            }
            if (
                forceVisibility &&
                forceVisibilityParam !== 'true' &&
                forceVisibilityParam !== 'false'
            ) {
                const newParams = new URLSearchParams(searchParams);
                newParams.set(paramName, 'true');
                setSearchParams(newParams);
            }
        }
    }, [forceVisibility, forceVisibilityParam, searchParams, setSearchParams]);
    return forceVisibility;
}
